import { useCallback, useEffect, useState } from 'react';

import { CloudDone, Image, Settings, Sync } from '@/package';
import {
  type ToolMenuItem,
  useTaskFrameStore,
  useToolMenuStore,
  useToolSettingStore,
} from '@/store';

import ToolbarGroup from './ToolbarGroup';
import ToolbarMenu from './ToolbarMenu';

const SettingToolbarGroup = () => {
  const [isToolSettingInitialized, setIsToolSettingInitialized] =
    useState(false);
  const {
    isPcdPointColorVisible,
    isShortTrackID,
    labelBoxTrackIDVisible,
    setGridVisible,
    setImagePopupVisible,
    setPcdPointColorVisible,
    setIsShortTrackID,
    setLabelBoxTrackIDVisible,
    setToolSettingVisible,
  } = useToolSettingStore();
  const { isUpsertLabelingPending } = useTaskFrameStore();
  const { currentFrame } = useTaskFrameStore();
  const toolMap = useToolMenuStore(state => state.toolMap);

  const imageDisabled = !currentFrame?.imagePath?.length;

  const onToolbarClick = useCallback((toolMenuItem?: Nullish<ToolMenuItem>) => {
    if (!toolMenuItem) return;

    useToolMenuStore.getState().select(toolMenuItem.id);
  }, []);

  useEffect(() => {
    const findByName = useToolMenuStore.getState().findByName;

    const pcdPointColorTool = findByName('pcdPointColor');
    const isShortTrackIDToggleTool = findByName('isShortTrackID');
    const labelTrackIDToggleTool = findByName('labelBoxTrackID');

    if (
      pcdPointColorTool &&
      pcdPointColorTool.isSelected !== isPcdPointColorVisible
    ) {
      useToolMenuStore.getState().select(pcdPointColorTool.id);
    }

    if (
      isShortTrackIDToggleTool &&
      isShortTrackIDToggleTool.isSelected !== isShortTrackID
    ) {
      useToolMenuStore.getState().select(isShortTrackIDToggleTool.id);
    }

    if (
      labelTrackIDToggleTool &&
      labelTrackIDToggleTool.isSelected !== labelBoxTrackIDVisible
    ) {
      useToolMenuStore.getState().select(labelTrackIDToggleTool.id);
    }

    setIsToolSettingInitialized(true);
  }, []);

  useEffect(() => {
    if (!isToolSettingInitialized) return;

    const findByName = useToolMenuStore.getState().findByName;

    const frameCamImageTool = findByName('frameCamImage');
    const gridShowTool = findByName('gridShow');
    const isShortTrackIDToggleTool = findByName('isShortTrackID');
    const labelTrackIDToggleTool = findByName('labelBoxTrackID');
    const pcdPointColorTool = findByName('pcdPointColor');
    const settingTool = findByName('settings');

    if (frameCamImageTool) {
      setImagePopupVisible(frameCamImageTool.isSelected);
    }

    if (gridShowTool) {
      setGridVisible(gridShowTool.isSelected);
    }

    if (isShortTrackIDToggleTool) {
      setIsShortTrackID(isShortTrackIDToggleTool.isSelected);
    }

    if (labelTrackIDToggleTool) {
      setLabelBoxTrackIDVisible(labelTrackIDToggleTool.isSelected);
    }

    if (pcdPointColorTool) {
      setPcdPointColorVisible(pcdPointColorTool.isSelected);
    }

    if (settingTool) {
      setToolSettingVisible(settingTool.isSelected);
    }
  }, [isToolSettingInitialized, toolMap]);

  return (
    <ToolbarGroup>
      <ToolbarMenu
        toolMenuItem={useToolMenuStore.getState().findByName('frameCamImage')}
        onClick={onToolbarClick}
        disabled={imageDisabled}
      >
        <Image className="size-4!" />
      </ToolbarMenu>

      <ToolbarMenu
        toolMenuItem={useToolMenuStore.getState().findByName('settings')}
        onClick={onToolbarClick}
      >
        <Settings className="size-4!" />
      </ToolbarMenu>

      <ToolbarMenu disabled>
        {isUpsertLabelingPending ? <Sync /> : <CloudDone />}
      </ToolbarMenu>

      {/* <ToolbarMenu className="hidden bg-error-500/20">
        <CloudAlert />
      </ToolbarMenu> */}
    </ToolbarGroup>
  );
};

export default SettingToolbarGroup;
